<ng-container *ngIf='!inputService.hidden && inputService.formInputDefinition && inputService.control' [formGroup]="inputService.formGroup">
	<input  
		[required]="inputService.inputConfig.required"
		disabled 
		[name]='inputService.formControlKey' 
		type='hidden' 
		[formControlName]='inputService.formControlKey' />
</ng-container>